import Icon from '@components/atoms/Icon';
import { Swiper, SwiperSlide } from '@components/molecules/Slider';
import React from 'react';

interface SliderProps {
  slides: React.ReactNode[];
  paginationClass: string;
  navigationPrevClass: string;
  navigationNextClass: string;
  breakpoints?: { [key: number]: { slidesPerView: number; spaceBetween: number } };
  wrapperClasses?: string; // Optional classes for the outer wrapper
}

const ProductSlider: React.FC<SliderProps> = ({
  slides,
  paginationClass,
  navigationPrevClass,
  navigationNextClass,
  breakpoints,
  wrapperClasses = '',
}) => {
  return (
    <div className={`slider-wrapper product-slider ${wrapperClasses}`}>
      <Swiper
        spaceBetween={24}
        slidesPerView={1.2}
        pagination={{
          el: `.${paginationClass}`,
          type: 'bullets',
          clickable: true,
          dynamicBullets: false,
        }}
        navigation={{
          nextEl: `.${navigationNextClass}`,
          prevEl: `.${navigationPrevClass}`,
        }}
        breakpoints={breakpoints || {
          768: {
            slidesPerView: 2.2,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 4.2,
            spaceBetween: 32,
          },
        }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index} className="flex-1">{slide}</SwiperSlide>
        ))}
      </Swiper>
      <div className="flex items-center justify-between space-x-4 mt-9 pr-5 lg:pr-16">
        <div className={paginationClass}></div>
        <div className="flex gap-x-3.5">
          <button
            type="button"
            className={`${navigationPrevClass} flex-shrink-0 flex justify-center items-center cursor-pointer border border-blue-1 bg-gradient-model-grey text-center font-extrabold rounded-[22px] w-11 h-11 p-3.75`}
          >
            <Icon name="carousel-arrow-left" />
          </button>
          <button
            type="button"
            className={`${navigationNextClass} flex-shrink-0 flex justify-center items-center cursor-pointer border border-blue-1 bg-gradient-model-grey text-center font-extrabold rounded-[22px] w-11 h-11 p-3.75`}
          >
            <Icon name="carousel-arrow-right" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductSlider;
